import React from 'react';
import { useMediaQuery } from 'react-responsive';

import logo from 'assets/logo.svg';
import Image from 'components/Base/Image';
import { SecondaryText, Title } from 'components/Base/Typography';
import { Colors, FontWeights, Screens } from 'core/CssVariables';
import { TLoginHeaderProps } from './type';
import { HeaderContainer } from './style';

const LoginHeader = ({
  title,
  description,
  className = '',
}: TLoginHeaderProps) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${Screens.ScreensMD})`,
  });

  return (
    <HeaderContainer>
      {isMobile && <Image src={logo} alt="opp-logo" className="logo" />}
      <div className={`text-container ${className}`}>
        <Title
          fontLevel={3}
          fontWeight={FontWeights.Regular}
          color={Colors.Black}
          className="mb-2"
        >
          {title}
        </Title>
        <SecondaryText
          fontLevel={5}
          fontWeight={FontWeights.Regular}
          color={Colors.LightGrey}
        >
          {description}
        </SecondaryText>
      </div>
    </HeaderContainer>
  );
};

export default LoginHeader;
